import { handleActions, combineActions } from 'redux-actions';
import actions from '../actions';

const { open, close } = actions.productModal;

const productModal = handleActions(
  {
    [combineActions(open, close)]: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
  },
  {
    active: false,
    productId: '',
    quantity: 0,
    productDiscount: {},
    editMode: false,
  }
);

export default productModal;



// WEBPACK FOOTER //
// ./src/reducers/productModal.js